import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import ViewWidget from "./ViewWidget";
import cloneDeep from "lodash/cloneDeep";


const ZAXIS_WIDTH = 4.5;

const FILTER_DEFAULTS = {
  aia_94: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: 2.5}
  },
  aia_131: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: 3.0}
  },
  aia_171: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: 4.0}
  },
  aia_193: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: 4.5}
  },
  aia_211: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true},
    view_widget: {symmetric: false, zaxis_max: 4.0}
  },
  aia_335: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: 3.0}
  },
  eit_171: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: null}
  },
  eit_195: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: null}
  },
  eit_284: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: null}
  },
  euvia_171: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: null}
  },
  euvia_195: {
    slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
    view_widget: {symmetric: false, zaxis_max: null}
  },
  euvia_284: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  euvib_171: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  euvib_195: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  euvib_284: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  suvi_94: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  suvi_131: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  suvi_171: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  suvi_195: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  suvi_284: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  fsi_174: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  fsi_304: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  xrt_al_mesh: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  xrt_al_poly: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  xrt_be_thin: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
  xrt_ti_poly: {
		slice_widget: {vignette_function: false, radial_power: 0, log_transform: true}, 
		view_widget: {symmetric: false, zaxis_max: null}
	},
}


const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  view_widget: {},
}

const DEFAULTS = {
  sim_widget: {
    domain: 'cor',
    time_of_interest: null,
  },
  slice_widget: {
    custom_view: false,
    euv_filter: 'aia_171',
    longitude: 0,
    b_angle: 0,
    p_angle: 0,
    r_distance: 1,
    radial_power: 0,
    vignette_function: false,
    log_transform: true,
    show_sim_lower_boundary: false,
    show_sim_upper_boundary: false,
    show_hpc_orientation: false,
  },
  view_widget: {
    fov: 0.53,
    fov_ticks: null,
    show_sun_center: false,
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    zaxis_min: -0.5,
    zaxis_max: 4,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
    grid: null,
  },
}

const sharedData = {
  slice_widget: {custom_view: null}
}

const flagTriggers = {
  slice_widget: {custom_view: true, euv_filter: true},
}

const flagDependencies = {
  slice_widget: {custom_view: null, euv_filter: null},
}

const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = null;
  switch (k) {
    case 'custom_view':
      if (!v) {
        modifiedParams = cloneDeep(FILTER_DEFAULTS[dependencies.slice_widget.euv_filter])
        modifiedParams.view_widget.zaxis_min = modifiedParams.view_widget.zaxis_max ? modifiedParams.view_widget.zaxis_max - ZAXIS_WIDTH : null;
      } else {
        modifiedParams = cloneDeep(PARAM_SCHEMA);
      }
      break;
    case 'euv_filter':
      modifiedParams = cloneDeep(FILTER_DEFAULTS[v])
      modifiedParams.view_widget.zaxis_min = modifiedParams.view_widget.zaxis_max ? modifiedParams.view_widget.zaxis_max - ZAXIS_WIDTH : null;
      break;
    default:
      modifiedParams = cloneDeep(PARAM_SCHEMA);
      break;
  }
  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const Euv = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='euv'
        toolName='EUV & X-Rays'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        flagValidators={flagValidators}
        flagDeps={flagDependencies}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        viewWidget={ViewWidget}
      />
    </>

  )
}

export default Euv;